export default __webpack_public_path__ + "static/media/EmployeeProductivity.d14eec71.png";